/**
 * Wallet handlers for new BFF API spec
 * GET /bff/wallets
 */

import { http, HttpResponse } from 'msw'
import { getMockData } from '../data'
import { processListRequest } from '../utils/filters'
import { applyDelay } from '../utils/delays'

export const walletHandlers = [
  /**
   * GET /api/bff/wallets
   * List wallets with aggregated metrics and chart data
   */
  http.get('/api/bff/wallets', async ({ request }) => {
    const url = new URL(request.url)
    const searchParams = url.searchParams

    // Apply delay simulation
    await applyDelay({ searchParams, preset: 'normal' })

    // Get mock data from centralized store
    const { wallets } = getMockData()

    // Note: date_start and date_end parameters would filter daily_data
    // For now, we return all data. Could be enhanced later.

    // Process list request with new filter system
    const result = processListRequest(wallets, searchParams, {
      defaultSort: 'name:asc',
      defaultLimit: 6
    })

    return HttpResponse.json(result)
  })
]
